import { MenuOutlined } from '@mui/icons-material'
import { Box, Button, IconButton, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { useDispatch } from 'react-redux';
import { setOpenSideMenue } from '../../../Redux/Reducers/globalSlice';
import { useNavigate } from 'react-router-dom';

function VenderHeader() {
    const theme = useTheme()
    const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
    const dispatch = useDispatch()
    const navigate = useNavigate()
    return (
        <Box className='header header2  position-relative'>
            <Box className="d-flex align-items-center justify-content-between w-100">
                {isPhone && (
                    <IconButton onClick={() => { dispatch(setOpenSideMenue(true)) }}> <MenuOutlined className='text-white pointer' /></IconButton>
                )}
                <Button className='btn-light-yellow' onClick={()=>{navigate('/home')}}>Go to Home</Button>
            </Box>
        </Box>
    )
}

export default VenderHeader
